import { useContext } from 'react';
import DealIdContext from './DealIdProvider';

export const useDealIdContext = () => {
  const context = useContext(DealIdContext);
  if (context === undefined) {
    throw new Error('Context must be used within a Provider');
  }
  return context;
};
